// JavaScript Document

$(window).on("load", function () {
  "use strict";

  /*----------------------------------------------------*/
  /*	Preloader
		/*----------------------------------------------------*/

  $("#loader").delay(100).fadeOut();
  $("#loader-wrapper").delay(100).fadeOut("fast");
});

$(document).ready(function () {
  "use strict";

  /*----------------------------------------------------*/
  /*	Hero Slider
		/*----------------------------------------------------*/

  $(".slider").slider({
    full_width: false,
    interval: 6000,
    transition: 1000,
    draggable: false,
    indicators: true,
  });

  $(".slide-next").click(function () {
    $(".slider").slider("next");
  });

  $(".slide-prev").click(function () {
    $(".slider").slider("prev");
  });

  /*----------------------------------------------------*/
  /*	Animated Scroll To Anchor
		/*----------------------------------------------------*/

  $(
    '.header a[href^="#"], .wsmenu a[href^="#"], .page a.btn[href^="#"], .page a.internal-link[href^="#"]'
  ).on("click", function (e) {
    e.preventDefault();

    var target = this.hash,
      $target = jQuery(target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 60, // - 200px (nav-height)
        },
        "slow",
        "easeInSine",
        function () {
          window.location.hash = "1" + target;
        }
      );
  });

  /*----------------------------------------------------*/
  /*	ScrollUp
		/*----------------------------------------------------*/

  $.scrollUp = function (options) {
    // Defaults
    var defaults = {
      scrollName: "scrollUp", // Element ID
      topDistance: 600, // Distance from top before showing element (px)
      topSpeed: 800, // Speed back to top (ms)
      animation: "fade", // Fade, slide, none
      animationInSpeed: 200, // Animation in speed (ms)
      animationOutSpeed: 200, // Animation out speed (ms)
      scrollText: "", // Text for element
      scrollImg: false, // Set true to use image
      activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
    };

    var o = $.extend({}, defaults, options),
      scrollId = "#" + o.scrollName;

    // Create element
    $("<a/>", {
      id: o.scrollName,
      href: "#top",
      title: o.scrollText,
    }).appendTo("body");

    // If not using an image display text
    if (!o.scrollImg) {
      $(scrollId).text(o.scrollText);
    }

    // Minium CSS to make the magic happen
    $(scrollId).css({ display: "none", position: "fixed", "z-index": "99999" });

    // Active point overlay
    if (o.activeOverlay) {
      $("body").append("<div id='" + o.scrollName + "-active'></div>");
      $(scrollId + "-active").css({
        position: "absolute",
        top: o.topDistance + "px",
        width: "100%",
        "border-top": "1px dotted " + o.activeOverlay,
        "z-index": "99999",
      });
    }

    // Scroll function
    $(window).on("scroll", function () {
      switch (o.animation) {
        case "fade":
          $(
            $(window).scrollTop() > o.topDistance
              ? $(scrollId).fadeIn(o.animationInSpeed)
              : $(scrollId).fadeOut(o.animationOutSpeed)
          );
          break;
        case "slide":
          $(
            $(window).scrollTop() > o.topDistance
              ? $(scrollId).slideDown(o.animationInSpeed)
              : $(scrollId).slideUp(o.animationOutSpeed)
          );
          break;
        default:
          $(
            $(window).scrollTop() > o.topDistance
              ? $(scrollId).show(0)
              : $(scrollId).hide(0)
          );
      }
    });

    // To the top
    $(scrollId).on("click", function (event) {
      $("html, body").animate({ scrollTop: 0 }, o.topSpeed);
      event.preventDefault();
    });
  };

  $.scrollUp();

  /*----------------------------------------------------*/
  /*	DateTimePicker
		/*----------------------------------------------------*/

  $("#datetimepicker").datetimepicker();

  /*----------------------------------------------------*/
  /*	Tabs #1
		/*----------------------------------------------------*/

  $("ul.tabs-1 li").on("click", function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs-1 li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  /*----------------------------------------------------*/
  /*	Tabs #2
		/*----------------------------------------------------*/

  $("ul.tabs-2 li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs-2 li").removeClass("displayed");
    $(".tab-content").removeClass("displayed");

    $(this).addClass("displayed");
    $("#" + tab_id).addClass("displayed");
  });

  /*----------------------------------------------------*/
  /*	Reviews Rotator Flexslider
		/*----------------------------------------------------*/

  $("#reviews-1 .flexslider").flexslider({
    animation: "fade",
    controlNav: true,
    directionNav: false,
    slideshowSpeed: 5000,
    animationSpeed: 2000,
    start: function (slider) {
      $("body").removeClass("loading");
    },
  });

  /*----------------------------------------------------*/
  /*	Single Image Lightbox
		/*----------------------------------------------------*/

  $(".image-link").magnificPopup({
    type: "image",
  });

  /*----------------------------------------------------*/
  /*	Video Link #1 Lightbox
		/*----------------------------------------------------*/

  $(".video-popup1").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com",
          src: "https://www.youtube.com/embed/SZEflIVnhH8",
        },
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Video Link #2 Lightbox
		/*----------------------------------------------------*/

  $(".video-popup2").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com",
          src: "https://www.youtube.com/embed/7e90gBu4pas",
        },
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Video Link #3 Lightbox
		/*----------------------------------------------------*/

  $(".video-popup3").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          index: "youtube.com",
          src: "https://www.youtube.com/embed/0gv7OC9L2s8",
        },
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Testimonials Rotator
		/*----------------------------------------------------*/

  var owl = $(".promo-holder");
  owl.owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    navBy: 1,
    nav: true,
    dots: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Testimonials Rotator
		/*----------------------------------------------------*/

  var owl = $(".promo-8-carousel");
  owl.owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    navBy: 1,
    nav: false,
    dots: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Gallery Photo Rotator
		/*----------------------------------------------------*/

  var owl = $(".images-carousel");
  owl.owlCarousel({
    items: 4,
    loop: true,
    autoplay: true,
    navBy: 1,
    autoplayTimeout: 4500,
    autoplayHoverPause: false,
    smartSpeed: 3000,
    responsive: {
      0: {
        items: 1,
      },
      640: {
        items: 1,
      },
      767: {
        items: 2,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Testimonials Rotator
		/*----------------------------------------------------*/

  var owl = $(".reviews-wrapper");
  owl.owlCarousel({
    items: 3,
    loop: true,
    autoplay: true,
    navBy: 1,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  });

  /*----------------------------------------------------*/
  /*	Brands Logo Rotator
		/*----------------------------------------------------*/

  var owl = $(".brands-carousel");
  owl.owlCarousel({
    items: 5,
    loop: true,
    autoplay: true,
    navBy: 1,
    nav: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: false,
    smartSpeed: 2000,
    responsive: {
      0: {
        items: 2,
      },
      550: {
        items: 3,
      },
      767: {
        items: 3,
      },
      768: {
        items: 4,
      },
      991: {
        items: 5,
      },
      1000: {
        items: 6,
      },
    },
  });

  /*----------------------------------------------------*/
 /*	Product
		/*----------------------------------------------------*/

 $("body").on("click", ".js-add-to-cart", function () {
    if ($(this).hasClass("variant")) {
      var quantity = 1;
      var id = $(this).attr("data-variant-id");
    } else {
      var productId = $(this).attr("data-product-id");
      var id = $(
        ".js-product[data-product-id='" +
          productId +
          "'] #product-select-" +
          productId +
          ""
      ).val();

      var quantity = $(
        ".js-quantity-field[data-product-id='" + productId + "']"
      ).val();
      if (isNaN(quantity)) {
        quantity = 1;
      }

      // --- Start of Code to Get Line Item Property Value ---
      var specialInstructionsInput = $('#special-instructions'); // Get the text input field by its ID
      var instructionsValue = specialInstructionsInput.val(); // Get the value from the input field
      // --- End of Code to Get Line Item Property Value ---
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      // --- Start of Modified Data Payload ---
      data: {
        id: id,
        quantity: quantity,
        properties: {
          "ملاحظات": instructionsValue // Add your property here
          // If you had other line item properties, you'd add them like:
          // "Another Property Name": anotherPropertyValue
        }
      },
      // --- End of Modified Data Payload ---
      success: function () {
        refreshCart();
        window.location.href = "/cart"; // This line redirects to the cart page after successful add
      },
      error: function (response) {
        var errorMessage = response.responseJSON
          ? response.responseJSON.description
          : theme.strings.cartError;
        alert(errorMessage);
        refreshCart(); // Consider removing or modifying this if the cart refresh happens on the redirect anyway
      },
    });
    return false; // Prevents default link behavior
  });

 // ... the rest of your JavaScript code ...

  $(".js-product-select").on("change", function () {
    var option = $(this).attr("data-option");
    var value = $(this).val();
    var productId = $(this).attr("data-product-id");

    $(
      ".js-product[data-product-id='" +
        productId +
        "'] #product-variants select[data-option='" +
        option +
        "']"
    )
      .val(value)
      .change();

    return false;
  });

  var variants = function (productId) {
    var data = JSON.parse(
      document.getElementById("ProductJson" + productId + "").innerHTML
    );
    var selectCallback = function (variant, selector) {
      var that = $(".js-product[data-product-id='" + productId + "']");
      if (variant) {
        if (variant.compare_at_price > variant.price) {
          $(that)
            .find(".old-price")
            .removeClass("d-none")
            .html(Shopify.formatMoney(variant.compare_at_price));
          $(that)
            .find(".default-price")
            .html(Shopify.formatMoney(variant.price));
        } else {
          $(that).find(".old-price").addClass("d-none");
          $(that)
            .find(".default-price")
            .html(Shopify.formatMoney(variant.price));
        }
      }
      if (variant.id == selector.product.variants[1].id) {
        $(that).find(".js-small-capacity").removeClass("d-none");
        $(that).find(".js-large-capacity").addClass("d-none");
        $(that).find(".js-small-calories").removeClass("d-none");
        $(that).find(".js-large-calories").addClass("d-none");
      } else {
        $(that).find(".js-small-capacity").addClass("d-none");
        $(that).find(".js-large-capacity").removeClass("d-none");
        $(that).find(".js-small-calories").addClass("d-none");
        $(that).find(".js-large-calories").removeClass("d-none");
      }
    };
    jQuery(function ($) {
      if ($("#product-select-" + productId + "").length > 0) {
        new Shopify.OptionSelectors("product-select-" + productId + "", {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true,
        });
      }
    });
  };

  $(".js-product-variants").each(function () {
    variants($(this).attr("data-product-id"));
  });

  /*----------------------------------------------------*/
  /*	Related Products
 /*----------------------------------------------------*/

  var relatedProducts = function () {
    if ($(".product-recommendations").length > 0) {
      loadRelatedProducts();
    }
    function loadRelatedProducts() {
      var productRecommendationsSection = document.querySelector(
        ".product-recommendations"
      );
      if (productRecommendationsSection === null) {
        return;
      }
      var productId = $(".product-recommendations").attr("data-product-id");
      var limit = $(".product-recommendations").attr("data-limit");
      var requestUrl =
        "/recommendations/products?section_id=related_products&limit=" +
        limit +
        "&product_id=" +
        productId;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML =
            container.querySelector(".product-recommendations").innerHTML;
        }
      };
      request.send();
    }
  };
  relatedProducts();

  /*----------------------------------------------------*/
  /*	Utilites
 /*----------------------------------------------------*/

  var accountLogin = function () {
    $(".js-go-to-forgotten-password").click(function () {
      $(".js-login").addClass("d-none");
      $(".js-forgotten-password").removeClass("d-none");
      return false;
    });
    $(".js-back-to-login").click(function () {
      $(".js-login").removeClass("d-none");
      $(".js-forgotten-password").addClass("d-none");
      return false;
    });
  };

  accountLogin();

  var wishlist = function () {
    $(".js-add-to-wishlist").each(function () {
      var productHandle = $(this).attr("data-product-handle") + ",";
      var wishlist = localStorage.getItem("wishlist");
      if (wishlist == null) {
        wishlist = "";
      }
      if (wishlist.indexOf(productHandle) >= 0) {
        $(this).addClass("active");
      }
    });
    $("body").on("click", ".js-add-to-wishlist", function () {
      var productHandle = $(this).attr("data-product-handle");
      var getWishlistProducts = localStorage.getItem("wishlist");
      if (getWishlistProducts == null) {
        getWishlistProducts = "";
      }
      getWishlistProducts = getWishlistProducts.replace(
        productHandle + ",",
        ""
      );

      if (!$(this).hasClass("active")) {
        $(this).addClass("active");

        localStorage.setItem(
          "wishlist",
          getWishlistProducts + productHandle + ","
        );
        return false;
      } else {
        $(this).removeClass("active");

        localStorage.setItem("wishlist", getWishlistProducts);
        return false;
      }
    });
  };
  wishlist();

  var refreshCart = function () {
    jQuery.getJSON("/cart.js", function (cart) {
      $(".js-cart-count").html(cart.item_count);
    });
  };
});
